export default "__VITE_ASSET__3def6b1e__"